import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './ServiceItem.module.scss';
import clsx from 'clsx';
import Link from '../Link/Link';
import { imageUrl } from '../../utils/imageUrl';
const ServiceItem = ({ logo, name, desc, site }) => {
  return (
    <>
      <div className={clsx(styles.item)}>
        <img src={imageUrl(logo)} alt="" className={clsx(styles.img, logo == 'placeholder.jpg' && styles.imgEmpty)} />
        <div className={clsx(styles.content)}>
          <Link
            className={clsx(styles.name)}
            onClick={() => {
              let fullUrl = site;
              if (!fullUrl.startsWith('http://') && !fullUrl.startsWith('https://')) {
                fullUrl = 'https://' + fullUrl; // По умолчанию https
              }

              window.open(fullUrl, '_blank', 'noopener,noreferrer');
            }}>
            {name}
          </Link>

          <div className={clsx(styles.desc)}>{desc}</div>
        </div>
      </div>
    </>
  );
};

export default ServiceItem;
